const baseTheme = require("./base-theme");

module.exports = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        primary: "#F57266",
    },
};
